"use strict";

export default bundle => {

    for(let i in bundle) {
        if (bundle.hasOwnProperty(i)) {
            window[i] = bundle[i];
        }
    }

};


// WEBPACK FOOTER //
// ./modules/loadRsForm.js